"use client";

import React from "react";

import { StakingCard } from "@/components/staking-card";

import { StakingContext } from "../context";

const REWARDS = [
  {
    img: "/icons/bitcoin.svg",
    cryptoName: "Bitcoin",
    cryptoSymbol: "BTC",
    percentage: 2.37,
    price: 97000,
  },
  {
    img: "/icons/avalanche.svg",
    cryptoName: "Avalanche",
    cryptoSymbol: "AVAX",
    percentage: 22.5,
    price: 44,
  },
  {
    img: "/icons/dogecoin.svg",
    cryptoName: "Dogecoin",
    cryptoSymbol: "DOGE",
    percentage: 112.5,
    price: 0.43,
  },
  {
    img: "/icons/ethereum.svg",
    cryptoName: "Ethtereum",
    cryptoSymbol: "ETH",
    percentage: 5.35,
    price: 3300,
  },
  {
    img: "/icons/solana.svg",
    cryptoName: "Solana",
    cryptoSymbol: "SOL",
    percentage: 26.0,
    price: 245,
  },
  {
    img: "/icons/cardano.svg",
    cryptoName: "Caradano",
    cryptoSymbol: "ADA",
    percentage: 10.25,
    price: 1,
  },
  {
    img: "/icons/tether.svg",
    cryptoName: "Thether",
    cryptoSymbol: "USDT",
    percentage: 15.0,
    price: 1,
  },
  {
    img: "/icons/shiba.svg",
    cryptoName: "Shiba INU",
    cryptoSymbol: "SHIB",
    percentage: 35.33,
    price: 0.00002662,
  },
  {
    img: "/icons/arbitrum.svg",
    cryptoName: "Arbitrum",
    cryptoSymbol: "ARB",
    percentage: 12.37,
    price: 0.87,
  },
  {
    img: "/icons/sushi.svg",
    cryptoName: "Sushi",
    cryptoSymbol: "SUSHI",
    percentage: 30.95,
    price: 1.25,
  },
  {
    img: "/icons/usdc.svg",
    cryptoName: "USD Coin",
    cryptoSymbol: "USDC",
    percentage: 88.5,
    price: 1,
  },
];

export function StakingCards() {
  const { selectedToken, setSelectedToken } = React.use(StakingContext);

  return (
    <div className="xs:grid-cols-2 grid grid-cols-1 gap-4 lg:col-span-2 xl:grid-cols-3">
      {REWARDS.map((token, key) => (
        <StakingCard
          key={key}
          {...token}
          selected={token.cryptoSymbol === selectedToken.cryptoSymbol}
          onSelectedChange={() => setSelectedToken(token)}
        />
      ))}
    </div>
  );
}
